import React from 'react';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import data from '../../../data/servicesAditionnels'
import Offer from './Offer'

const options = [
  {value: 'remp', label: "Véhicule de remplacement"},
  {value: 'loc', label: "Véhicule de location"},
  {value: 'gardAni', label: "Garde d'animaux"},
  {value: 'gardEnf', label: "Garde d'enfants"},
  {value: 'achatVehicule', label: "Coach Auto"},
  {value: 'demenagment', label: "Démenagement"},
  {value: 'hebergement', label: "Hébergement"},
  {value: 'deplVoiture', label: "Déplacement de voiture"},
  {value: 'servicePersonne', label: "Service à domicile"},
  {value: 'mobilreduite', label: "Mobilté réduite"}
];

const animatedComponents = makeAnimated();

export default class AnimatedMulti extends React.Component {
  state ={
    value:this.props.defaultOptions
  };

  onChangeFunc = (value) => {
    this.setState({value})
  };

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      value: nextProps.defaultOptions
    })
  }

  render() {
    const filter = data.filter(offer => {
      let found = false;
      (this.state.value||[]).forEach(v => {
        if (!found && offer.tags.includes(v.value)) {
          found = true
        }
      });
      return found || ((this.state.value||[]).length) ===0;
    });
    return (
      <div className="offers">
        <Select
          className="offers-search"
          closeMenuOnSelect={false}
          components={animatedComponents}
          onChange={this.onChangeFunc}
          value={this.state.value}
          placeholder={'Chercher un service...'}
          defaultValue={this.props.defaultOptions || []}
          isMulti
          isSearchable={true}
          options={this.props.options || []}/>
        <div className="offers-list">
          <div className="offers-row">
            <div className="row">
                {filter.map(offer => <Offer offer={offer} />)}
              </div>
          </div>
        </div>
      </div>
    );
  }
}

